import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReplaySubject, startWith, map } from 'rxjs';
import { BoardsService } from 'src/app/service/boards.service';

@Component({
  selector: 'app-onetime-task',
  templateUrl: './onetime-task.component.html',
  styleUrls: ['./onetime-task.component.scss'],
  standalone: false,  // NOSONAR
})
export class OnetimeTaskComponent implements OnInit {

  selectedRegions: { label: string; value: string }[] = [];

  userdropdownTemp: any = [];
  userdropdown: any = [];
  temp2: string;
  userData;
  selected_puser;
  selected_suser;
  selected_region;
  selected_period;
  selected_board;
  selected_duedate;
  selected_sequence = 0;

  temp4;
  temp5;

  temp: string;
  temp3: string;
  regionList: any;
  selectedRegionsTemp: any = [];
  taskData;
  selectedTask;


  periodData;
  boardData;


  successMessage = '';
  errorMessage = '';

  selected_region_Temp_final: any = [];
  userID;
  usertemp: string;
  userInfo: any;

  s_region_flag: boolean = true;
  selected_reg;
  selected_pValue: any;
  selected_sValue: any;


  activateAdd: boolean = true;
  activateSave: boolean = false;

  function = "Create";
  boardTaskID;
  taskDataDrpDwn: any[];
  taskFilter: FormControl = new FormControl('');
  filteredTasks: ReplaySubject<{ label: string; value: string }[]> = new ReplaySubject(1);
  puserFilter: FormControl = new FormControl('');
  filteredPusers: ReplaySubject<{ label: string; value: string }[]> = new ReplaySubject(1);
  suserFilter: FormControl = new FormControl('');
  filteredSusers: ReplaySubject<{ label: string; value: string }[]> = new ReplaySubject(1);
  regionFilterCtrl: FormControl = new FormControl();
  filteredRegions: ReplaySubject<{ label: string; value: string }[]> = new ReplaySubject(1);
  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly boardService: BoardsService) {


    this.ngxUiLoaderService.start("loader-01");

    //fetch from local-storage
    this.temp = localStorage.getItem('task-data');
    this.taskData = JSON.parse(this.temp);

    const temp = [];
    let obj;

    this.taskData.forEach(element => {

      obj = { "label": element.description, "value": element.taskID };
      temp.push(obj);

    });

    this.taskDataDrpDwn = temp;

    //fetch from local-storage
    this.temp3 = localStorage.getItem('region-data');
    this.regionList = JSON.parse(this.temp3);

    this.regionList?.forEach(element => {
      

     const obj = { "label": element.region, "value": element.region_code };
      this.selectedRegionsTemp.push(obj);
    });

    this.selectedRegions = this.selectedRegionsTemp;


    //fetch from local-storage
    this.temp2 = localStorage.getItem('users-data');
    this.userData = JSON.parse(this.temp2);


    this.userData?.forEach(element => {
      

      const obj = { "label": element.firstName + ' ' + element.lastName, "value": element.userPrincipalName };
      this.userdropdownTemp.push(obj);
    });

    this.userdropdown = this.userdropdownTemp;


    this.temp5 = localStorage.getItem('board-data');
    this.boardData = JSON.parse(this.temp5);


    this.ngxUiLoaderService.stop("loader-01");
  }

  ngOnInit(): void {  
    this.taskFilter.valueChanges.pipe(
      startWith(''), map(search => {
        if (search) {
          return this.filtertasks(search);
        }

        if (this.taskDataDrpDwn) {
          return this.taskDataDrpDwn.slice();
        }

        return [];
      }))
      .subscribe(filtered => {
        this.filteredTasks.next(filtered);
      });
    this.puserFilter.valueChanges.pipe(
      startWith(''), map(search => {
        if (search) {
          return this.filterPuser(search);
        }

        if (this.userdropdown) {
          return this.userdropdown.slice();
        }

        return [];
      }))
      .subscribe(filtered => {
        this.filteredPusers.next(filtered);
      });
    this.suserFilter.valueChanges.pipe(
      startWith(''), map(search => {
        if (search) {
          return this.filterSuser(search);
        }

        if (this.userdropdown) {
          return this.userdropdown.slice();
        }

        return [];
      }))
      .subscribe(filtered => {
        this.filteredSusers.next(filtered);
      });
    this.regionFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search =>
          {
          if (search) {
            return this.filterRegions(search);
          }

          if (this.selectedRegions) {
            return this.selectedRegions.slice();
          }

          return [];
        }
        )
      )
      .subscribe(filtered => {
        this.filteredRegions.next(filtered);
      });
  }
  filtertasks(search: string): any[] {
    if (!search) {
      return this.taskDataDrpDwn.slice();
    }

    return this.taskDataDrpDwn.filter(user =>
      user.label.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterPuser(search: string): any[] {
    if (!search) {
      return this.userdropdown.slice();
    }

    return this.userdropdown.filter(user =>
      user.label.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterSuser(search: string): any[] {
    if (!search) {
      return this.userdropdown.slice();
    }

    return this.userdropdown.filter(user =>
      user.label.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterRegions(search: string): { label: string; value: string }[] {
    // return filtered array
    return this.selectedRegions.filter(region =>
      region.label.toLowerCase().includes(search.toLowerCase())
    );

  }
  isAllSelected(): boolean {
    return this.selected_region?.length == this.selectedRegions.length; // NOSONAR
  }

  isIndeterminate(): boolean {
    return this.selected_region?.length > 0 && !this.isAllSelected();
  }
  toggleSelectAll(event: any): void {
    if (event.checked) {
      this.selected_region = [...this.selectedRegions];
    } else {
      this.selected_region = [];
    }
  }

  addtask() {


    console.info("board", this.selected_board, "task", this.selectedTask, "due date", this.selected_duedate, "sequence",
      this.selected_sequence, "puser", this.selected_puser, "suser", this.selected_suser, "region", this.selected_region,
      "updaetd by", this.userID);

    if (this.selected_board == undefined || this.selectedTask == undefined || this.selected_duedate == undefined) { // NOSONAR
      this.errorMessage = "Please fill in the required fields!";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else if ((!this.selected_puser && !this.selected_region) || (!this.selected_puser && this.selected_region == '')) { // NOSONAR
      this.errorMessage = "At least a Primary user or a region must be selected.";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else {


      if (this.selected_puser) {
        this.selected_pValue = this.selected_puser.value;
      }


      if (this.selected_suser) {
        this.selected_sValue = this.selected_suser.value;
      }

      if (this.selected_region) {
        this.selected_region.forEach(element => {

          this.selected_region_Temp_final.push(element.value);
        });

        this.selected_reg = this.selected_region_Temp_final.toString();
      }

      this.addtask_sub()



    }




  }

  addtask_sub() {
    const userData = sessionStorage?.getItem('FGA');
    if (userData) {
      this.userID = JSON.parse(userData)?.user?.userPrincipalName;
    }


    // not undefined
    if (!this.selected_puser) {
      this.selected_puser = null;
    }
    if (!this.selected_suser) {
      this.selected_suser = null;
    }
    if (this.selected_region == '' || !this.selected_region) { // NOSONAR
      this.selected_region = null;
    }

    let due;

    if (this.selected_duedate) {

      // format due date

      const due_split = this.selected_duedate.split('T');
      const dueYear = due_split[0].split('-');


      //  mm-dd-yyyy hh:mi
      due = dueYear[1] + '-' + dueYear[2] + '-' + dueYear[0] + ' ' + due_split[1];

      console.info("due", due);

    }


    const dataArr = {
      "intuserID": this.userID,
      "boardTaskID": null,
      "boardID": this.selected_board,
      "taskID": this.selectedTask.value,
      "due": due,
      "sequence": this.selected_sequence,
      "primaryUser": this.selected_pValue,
      "secondaryUser": this.selected_sValue,
      "regions": this.selected_reg
    }



    this.ngxUiLoaderService.start("loader-01");

    this.boardService.addoneTimeTask(dataArr).subscribe(result => {
      if (!result) {
        this.errorMessage = 'Task already exists!';
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);
        this.ngxUiLoaderService.stop("loader-01");
      }

      else if (result) {

        this.boardTaskID = result.split(':')[1];
        this.successMessage = 'Board Task Created Successfully!';
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 6500);

        this.ngxUiLoaderService.stop("loader-01");

        // Change to edit once saved
        this.function = "Edit";
        this.activateAdd = false;
        this.activateSave = true;

      }
    });

    // reset values
    this.selected_region_Temp_final = [];
    this.s_region_flag = true;
  }


  savetask() {


    if (this.selected_duedate == undefined) { // NOSONAR
      this.errorMessage = "Please fill in the required fields!";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else if ((!this.selected_puser && !this.selected_region) || (!this.selected_puser && this.selected_region == '')) { // NOSONAR
      this.errorMessage = "At least a Primary user or a region must be selected.";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else {

      this.savetask_sub()

    }
  }

  savetask_sub() {

    if (this.selected_puser) {
      this.selected_pValue = this.selected_puser.value;
    }


    if (this.selected_suser) {
      this.selected_sValue = this.selected_suser.value;
    }

    if (this.selected_region) {
      this.selected_region.forEach(element => {

        this.selected_region_Temp_final.push(element.value);
      });

      this.selected_reg = this.selected_region_Temp_final.toString();
    }


    // not undefined
    if (!this.selected_puser) {
      this.selected_puser = null;
    }
    if (!this.selected_suser) {
      this.selected_suser = null;
    }
    if (this.selected_region == '' || !this.selected_region) { // NOSONAR
      this.selected_region = null;
    }



    const due_split = this.selected_duedate.split('T');
    const dueYear = due_split[0].split('-');

    //  mm-dd-yyyy hh:mi
    const due = dueYear[1] + '-' + dueYear[2] + '-' + dueYear[0] + ' ' + due_split[1].substring(0, 5);

    const dataArr = {
      "intuserID": this.userID,
      "boardTaskID": this.boardTaskID,
      "boardID": this.selected_board,
      "taskID": this.selectedTask.value,
      "due": due,
      "sequence": this.selected_sequence,
      "primaryUser": this.selected_pValue,
      "secondaryUser": this.selected_sValue,
      "regions": this.selected_reg
    }

    this.ngxUiLoaderService.start("loader-01");

    this.boardService.saveoneTimeTask(dataArr).subscribe(_result => {
      

      this.successMessage = 'Board Task Saved Successfully!';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);

      this.ngxUiLoaderService.stop("loader-01");
      // }
    });

    // reset values

    this.selected_region_Temp_final = [];
    this.s_region_flag = true;
  }



  flagFunc() {
    if (this.selected_region.length == 0) { // NOSONAR
      this.s_region_flag = true;
    }
    else if (this.selected_region.length > 0) {
      this.s_region_flag = false;
    }
    else if (this.selected_region == undefined) { // NOSONAR
      this.s_region_flag = true;
    }
  }

}
